import ScrollTrigger from 'gsap/dist/ScrollTrigger';

export const clearScrollTriggers = () => {
    const triggers = ScrollTrigger.getAll();

    triggers.forEach((trigger) => {
        trigger.kill();
    });
};
